import React from 'react'
import {AiOutlineMessage} from 'react-icons/ai';
import {Input, InputWrapper} from "@mantine/core";

const SmsWidget = ({sms,errors,setSMS}) => {
    return (
        <>
            <InputWrapper label="Introduceți codul primit prin SMS">
                <Input styles={{input:{'&:focus':{outline:'none',borderColor: '#ced4da'},textAlign:'center',fontSize:'18px'}}} onChange={(e) => setSMS(e.target.value)} value={sms} type="text"/>
            </InputWrapper>
            {errors.length > 0 && <p className="text-red-500 mt-2 text-[14px]">{errors}</p>}
        </>
    )
}

export default SmsWidget